
<template>
  <div>
    <v-row v-if="newItem.kind == 'react'" class="ml-n5">
      <v-col>
        <v-subheader>Valor mínimo desejado</v-subheader>
        <v-sheet class="ml-2" max-width="1000" >
          <v-slide-group mandatory v-model="newItem.minimum">
            <v-slide-item :value="face.value" v-for="(face,idx) in allFaces" :key="'ckind3'+idx" v-slot:default="{ active, toggle }">
              <v-btn fab small class="mr-4" depressed rounded :input-value="active" @click="toggle" 
                :active-class="`${face.color} white--text`"
              >
                <v-icon large :color="!active? face.color : ''"> {{face.icon}} </v-icon>
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </v-sheet><br>
        Responstas abaixo desse valor serão consideradas como inconformidades
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      newItem: this.$attrs.newItem,
      allFaces: [
        {value: '1', color: 'error', icon:'mdi-emoticon-frown-outline'},
        {value: '2', color: 'red', icon:'mdi-emoticon-sad-outline'},
        {value: '3', color: 'amber', icon:'mdi-emoticon-neutral-outline'},
        {value: '4', color: 'info', icon:'mdi-emoticon-outline'},
        {value: '5', color: 'success', icon:'mdi-emoticon-excited-outline'},
      ],
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>